import styled from 'styled-components'
import { PlacesSelect } from 'commons/js/ui/PlacesSelect'
import { themeColor, themeFontWeight } from '@elparking/components'

const StyledPlaceSelect = styled(PlacesSelect)`
    border: 1px solid ${({ error }) => error ? themeColor('error') : themeColor('lightGray')};
    border-radius: 4px;
    width: 100%;
    min-width: 100%;
    height: 100%;
    position: relative;

    &:focus-visible {
        outline: 1px solid ${themeColor('focusColor')};
    }

    .Select__menu-list {
        padding: 0;
        min-height: 0;
    }

    .Select__menu,
    .Select__menu-outer {
        background: ${themeColor('white')};
    }

    .Select__menu {
        margin: 0;
        padding: 0;
        max-width: 100%;
    }

    .Select__option--is-focused {
        background-color: ${themeColor('accent10')};
        color: ${themeColor('darkMain')};
    }

    .Select__option--is-selected {
        background-color: ${themeColor('accent20')};
        color: ${themeColor('darkMain')};
    }

    .Select__indicators {
        padding: 0 1em;
    }

    .Select__control {
        border: 0;
        border-radius: 4px;
    }

    .Select__placeholder {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 2px 0px;
        color: ${themeColor('gray90')} ;
    }

    .Select__single-value {
        padding: 2px 0px;
        font-weight: ${themeFontWeight('regular')}
    }

    .Select__input-container {
        font-weight: ${themeFontWeight('regular')};
        position: relative;
    }

    input.Select__input {
        position: absolute;
        margin-top: -3px !important;
    }

    .Select__control--is-focused
    .Select__value-container
    .Select__single-value {
        color: ${themeColor('gray90')};
    }
    
`

export default StyledPlaceSelect
